import React, { useContext, useEffect, useState } from "react"
import { Preguntas } from "../components/Preguntas"
import { Box, Container, Typography, Grid, Stack } from "@mui/material"
import { LinearProgress } from "@mui/material"
import { Button } from "@mui/material"
import { HelpTemas } from "../components/HelpTemas"
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useTranslation } from "react-i18next"
import { useSecurity } from "../hooks/useSecurity"
import { CuestionSkeleton } from "../components/commons/CuestionSkeleton"
import { GeneralContext } from '../context/GeneralContext'
import { CuestionContext } from "../context/CuestionContext"
import { DobleCircularProgressWithLabel } from "../components/commons/DobleCircularProgressWithLabel"
import Modal from "../components/commons/Modal";
import ModalConfirmar from '../components/commons/ModalConfirmar'
import colors from "../theme/colors"
import ejeFinalizado from "../images/ejeFinalizado.png"
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import LoadingButton from '@mui/lab/LoadingButton'

export const Cuestion = () => {
    const {
        cuestion,
        PreguntaRespondida,
        PreguntaAnterior,
        RespuestaSeleccionada,
        backToAxes,
        navigate,
        anularEje,
        user
    } = useContext(CuestionContext);

    const { questionaryPercentage } = useContext(GeneralContext)
    const [showMaxNoAplica, setShowMaxNoAplica] = useState(true);
    const { t } = useTranslation()
    const { loading, setLoading } = useContext(CuestionContext)
    useSecurity();
    
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

    useEffect(() => {
        //if (cuestion?.ultimaCuestion)
        //navigate("/Ejes");
        setShowMaxNoAplica(true);
    }, [cuestion]);

    return (
        <>
            <Typography variant="h1" display={'none'}>Cuestion</Typography>
            {cuestion ? (
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Grid item sx={{ width: '100%' }}>
                        <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            justifyContent="space-between"
                            alignItems="center"
                            spacing={2}
                            sx={{ height: '100px', marginTop: '1em', paddingBottom: '1em', marginY: { xs: 2, md: 0 } }}
                        >
                            {cuestion.pregunta ? (
                                <Button
                                    variant="contained"
                                    startIcon={<KeyboardArrowRightIcon  sx={{ color: colors.textMain }} />}
                                    onClick={backToAxes}
                                >
                                    {t("cuestion.btnVolver")}
                                </Button>
                            ) : ("")}

                            <Stack
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                spacing={2}
                            >
                                <Typography variant="parrafo" sx={{ fontWeight: 'bold' }}>
                                    {t("general.porcentajeTotal")}
                                </Typography>
                                <DobleCircularProgressWithLabel percentage={questionaryPercentage} size={60} fontSize={"1em"} />
                            </Stack>
                        </Stack>

                        <Typography variant="h2" fontSize={'1.2em'} marginTop={0}>
                            {t("cuestion.ejeTitulo") + cuestion?.ejeActual?.texto}
                        </Typography>

                        {/* linea progreso cuestionario */}
                        <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} spacing={1}>
                            <Box sx={{ width: "100%" }}>
                                <LinearProgress
                                    variant="determinate"
                                    value={cuestion.porcentajeEje}
                                />
                            </Box>
                            <Box sx={{ minWidth: 35 }}>
                                <Typography variant="parrafoPrimary">
                                    {cuestion.porcentajeEje}%
                                </Typography>
                            </Box>
                        </Stack>
                        {/* Preguntas del cuestionario */}
                        <Stack
                            direction={{ xs: 'column', sm: 'column', md: 'row' }}
                            justifyContent="space-between"
                            spacing={2}
                            sx={{
                                paddingY: '2em',
                            }}
                        >

                            {cuestion.pregunta ? (
                                <Box
                                // sx={{ flexBasis: cuestion?.pregunta?.texto_ayuda?.length > 0 ? '80%' : '100%' }}
                                >
                                    <Preguntas pregunta={cuestion.pregunta} />
                                    <Stack direction="row" spacing={2} justifyContent="space-between">

                                        <Box display="flex" > {/* Envolver los dos primeros botones en un componente Box */}
                                            <LoadingButton
                                                onClick={() => {
                                                    setLoading(true);
                                                    PreguntaAnterior(cuestion.pregunta);
                                                }}
                                                loading={loading}
                                                variant="contained"
                                                disabled={cuestion.porcentajeEje === 0}
                                            >
                                                {t("cuestion.btnAnterior")}
                                            </LoadingButton>
                                            <Box sx={{ width: '20px' }} />
                                            {/* Boton siguiente pregunta */}
                                            <LoadingButton
                                                onClick={() => {
                                                    setLoading(true);
                                                    PreguntaRespondida(RespuestaSeleccionada);
                                                }}
                                                loading={loading}
                                                variant="contained"
                                                disabled={!RespuestaSeleccionada}
                                            >
                                                {t("cuestion.btnSiguiente")}
                                            </LoadingButton>
                                        </Box>
                                    </Stack>
                                </Box>
                            ) : (
                                <Box
                                // sx={{ flexBasis: cuestion?.pregunta?.texto_ayuda?.length > 0 ? '80%' : '100%' }}
                                >
                                    <Stack direction={{ xs: 'column', sm: 'column', md: 'row' }} spacing={4} alignItems={"center"} >
                                            <Box sx={{ width: '60%', height: 'auto', marginBottom: "2em" }} padding={{ sx: 0, md: "1em" }} >
                                                <img src={ejeFinalizado} alt="Eje finalizado" width="90%" height="auto" />
                                        </Box>
                                        <Stack spacing={4} marginBottom={{ xs: "1em" }} textAlign={"justify"}>
                                            <Typography variant="h3" color="primary" sx={{ fontWeight: 'bold' }}>
                                                {t('cuestion.ejeFinalizadoTitulo')}
                                            </Typography>
                                                <Typography variant="h5" color="primary">
                                                {t('cuestion.ejeFinalizadoTexto')}
                                            </Typography>
                                            <Stack direction="row" spacing={2} justifyContent="space-between">

                                                <Box display="flex" > {/* Envolver los dos primeros botones en un componente Box */}
                                                    <Button
                                                        disabled={cuestion.porcentajeEje === 0}
                                                        onClick={() => {
                                                            PreguntaAnterior(cuestion.pregunta);
                                                        }}
                                                        variant="contained"
                                                        startIcon={<KeyboardArrowLeftIcon sx={{ color: colors.textMain }} />}
                                                    >
                                                        {t("cuestion.btnPreguntaAnterior")}
                                                    </Button>
                                                    <Box sx={{ width: '20px' }} />
                                                    <Button
                                                        variant="contained"
                                                        endIcon={<KeyboardArrowRightIcon  sx={{ color: colors.textMain }} />}
                                                        onClick={backToAxes}
                                                    >
                                                        {t("cuestion.btnVolver")}
                                                    </Button>
                                                </Box>
                                            </Stack>
                                        </Stack>

                                    </Stack>
                                </Box>
                            )}

                            <Stack textAlign={"justify"} alignItems={'center'} sx={{
                                // flexBasis: cuestion?.pregunta?.texto_ayuda?.length > 0 ? '35%' : '0%', 
                                display: cuestion.ultimaCuestion && "none"
                            }}>
                                <HelpTemas texto={cuestion?.pregunta?.texto_ayuda} />
                            </Stack>
                        </Stack>
                    </Grid>
                    {cuestion?.maxNoAplica &&
                        <Modal title={t("cuestion.tituloMaxNoAplica")} content={t("cuestion.textoMaxNoAplica")} open={showMaxNoAplica}  >
                            <ModalConfirmar
                                title={t("eje.desactivarEjePregunta")}
                                text={t("eje.desactivarEjeBody")}
                                cancelText={t("general.cancelar")}
                                continueText={t("general.aceptar")}
                                onContinue={() => { anularEje(user, cuestion.pregunta.id_eje).then(() => navigate("/Ejes")) }} >
                                <Button>{t("cuestion.anularEje")}</Button>
                            </ModalConfirmar>
                            <Button variant="contained" onClick={() => { setShowMaxNoAplica(false) }} >{t("cuestion.cambiarRespuesta")}</Button>
                        </Modal>
                    }
                </Grid>
            ) : (
                <CuestionSkeleton />
            )}
        </>
    )
}
